import { UsuarioDTO } from "app/main/apps/shared/interfaces/usuario.interface";
import { Component, OnInit } from "@angular/core";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { ConfiguracionTarjetaInicio } from "../shared/models/configuracion-tarjeta-inicio.model";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";

import { UsuarioService } from "../shared/services/rest/usuario.service";
import { DashboardDTO } from "../shared/interfaces/dashboard.interface";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

import { finalize } from "rxjs/operators";

enum botones {
    IR_A_COTIZACIONES = "IR A COTIZACIONES",
    IR_A_OOTT = "IR A ÓRDENES DE TRABAJO",
    IR_A_OOCC = "IR A ÓRDENES DE COMPRA",
    IR_A_Facturas = "IR A FACTURAS",
}
@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
    tarjetas: ConfiguracionTarjetaInicio[];

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _usuarioSrvc: UsuarioService,
        private _fuseProgressBarService: FuseProgressBarService
    ) {
        this.tarjetas = [];
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    async ngOnInit() {
        this._fuseProgressBarService.show();
        this._usuarioSrvc
            .fetchDashboard()
            .pipe(finalize(() => this._fuseProgressBarService.hide()))
            .subscribe((tarjetas) => {
                this.configuraTarjetas(tarjetas);
            });
    }

    setCantidadTarjeta(tarjetas: DashboardDTO) {
        const keys: string[] = Object.keys(tarjetas);
        this.tarjetas.map((tarjeta) => {
            if (keys.includes(tarjeta.id)) {
                tarjeta.cantidad = tarjetas[tarjeta.id];
            }
            return tarjeta;
        });
    }

    configuraTarjetas(tarjetas: DashboardDTO) {
        //const tarjetasAux: ConfiguracionTarjetaInicio[] = [];
        //if (rol === CONFIG.roles.supervisor.rol) {
        this.tarjetas.push(
            this.generaTarjeta(
                "porCotizar",
                "Solicitudes por cotizar",
                "Solicitudes de cotización que debe responder",
                null,
                true,
                botones.IR_A_COTIZACIONES,
                "/cotizaciones",
                { situacion: 2, nombre: "No cotizadas" }
            )
        );
        //cantidad: dashBoard.porCotizar,
        this.tarjetas.push(
            this.generaTarjeta(
                "nuevas",
                "Trabajos sin invitación",
                "Trabajos solicitados a los que debe invitar contratistas",
                null,
                true,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { idEstado: 0, nombre: "Nueva" }
            )
        );
        //cantidad: dashBoard.nuevas,

        this.tarjetas.push(
            this.generaTarjeta(
                "porAdjudicar",
                "Trabajos por Adjudicar",
                "Trabajos para los que debe asignar un contratista",
                null,
                true,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { idEstado: 1, nombre: "Enviada" }
            )
        );
        //cantidad: dashBoard.porAdjudicar,

        this.tarjetas.push(
            this.generaTarjeta(
                "enEjecucion",
                "Trabajos en ejecución",
                "Trabajos que actualmente estan ejecutándose",
                null,
                false,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { idEstado: 3, nombre: "En ejecución" }
            )
        );
        //cantidad: dashBoard.enEjecucion,

        this.tarjetas.push(
            this.generaTarjeta(
                "porPagarAContratista",
                "Trabajos por pagar",
                "Trabajos terminados para los que falta registrar el pago al contratista",
                null,
                true,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { pagoTrabajo: 2, nombre: "Pendiente" }
            )
        );
        //cantidad: dashBoard.porPagarAContratista,

        this.tarjetas.push(
            this.generaTarjeta(
                "porFacturar",
                "Órdenes de Compra por Facturar",
                "Órdenes de compra para las que aún no se ha registrado la factura",
                null,
                true,
                botones.IR_A_OOCC,
                "/ordenes-de-compra",
                {
                    idEstado: 1,
                    nombre: "No Facturados",
                    idRecepcion: 2,
                    nombreRecepcion: "Recibidas",
                }
            )
        );
        //cantidad: dashBoard.porFacturar,

        this.tarjetas.push(
            this.generaTarjeta(
                "solicitudesPorCotizar",
                "Solicitudes pendientes de cotización",
                "Requerimientos a la espera de cotización por FaciliTIC",
                null,
                false,
                botones.IR_A_COTIZACIONES,
                "/cotizaciones",
                { situacion: 2, nombre: "No cotizadas" }
            )
        );
        //cantidad: dashBoard.solicitudesPorCotizar,

        this.tarjetas.push(
            this.generaTarjeta(
                "solicitudesCotizadasVigentes",
                "Cotizaciones disponibles",
                "Cotizaciones para las que puede pedir los servicios",
                null,
                true,
                botones.IR_A_COTIZACIONES,
                "/cotizaciones",
                {
                    situacion: 1,
                    nombre: "Cotizadas",
                    vigencia: 1,
                    nombreVigencia: "Vigentes",
                }
            )
        );
        //dashBoard.solicitudesCotizadasVigentes,

        this.tarjetas.push(
            this.generaTarjeta(
                "otEnEjecucion",
                "Trabajos en Ejecución",
                "Órdenes de Trabajo actualmente activas",
                null,
                false,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { idEstado: 3, nombre: "En ejecución" }
            )
        );
        //cantidad: dashBoard.otEnEjecucion,

        this.tarjetas.push(
            this.generaTarjeta(
                "otPorRecibir",
                "Trabajos por recibir",
                "Trabajos terminados que debe revisar y recibir",
                null,
                true,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { idEstado: 4, nombre: "Terminada" }
            )
        );
        //cantidad: dashBoard.otPorRecibir,

        this.tarjetas.push(
            this.generaTarjeta(
                "oottSinOC",
                "Órdenes de trabajo sin Orden de Compra",
                "Órdenes de trabajo a las que aún no se asigna una orden de compra",
                null,
                true,
                botones.IR_A_OOTT,
                "/ordenes-de-trabajo",
                { situacion: 2, nombre: "Sin OOCC" }
            )
        );
        //cantidad: dashBoard.oottSinOC,

        this.tarjetas.push(
            this.generaTarjeta(
                "ooccPorRecibir",
                "Órdenes de Compra por Recibir",
                "Órdenes de compra sin documento de recepción (ROC/HES)",
                null,
                true,
                botones.IR_A_OOCC,
                "/ordenes-de-compra",
                {
                    idRecepcion: 1,
                    nombreRecepcion: "No Recibidas",
                }
            )
        );
        //cantidad: dashBoard.ooccPorRecibir,

        this.tarjetas.push(
            this.generaTarjeta(
                "facturasPorPagar",
                "Facturas por Pagar",
                "Facturas de FaciliTIC que aún estan pendientes de pago",
                null,
                true,
                botones.IR_A_Facturas,
                "/facturas",
                {
                    idEstado: 1,
                    nombre: "Impagas",
                }
            )
        );
        //cantidad: dashBoard.facturasPorPagar,

        this.setCantidadTarjeta(tarjetas);
    }

    generaTarjeta(
        id: string,
        titulo: string,
        subtitulo: string,
        cantidad: number,
        requiereAccion: boolean,
        nombre: string,
        url: string,
        queryParams: any
    ): ConfiguracionTarjetaInicio {
        const ruta = { nombre, url, queryParams };
        const tarjeta = new ConfiguracionTarjetaInicio(
            id,
            titulo,
            subtitulo,
            cantidad,
            ruta,
            requiereAccion
        );
        return tarjeta;
    }
}
